import { Entity, formatTicker } from '@toggle/toggle';
import React from 'react';

import { AssetLogoContainer } from '~/components/asset-logo-container/AssetLogoContainer';
import { WatchlistTrigger } from '~/components/watchlist/watchlist-trigger/WatchlistTrigger';

import * as S from './EntityHeaderWatchlist.styles';

export const EntityHeaderWatchlist = ({ entity }: { entity: Entity }) => {
  const ticker = formatTicker(entity);
  const entityName = entity.name_short || entity.name_full;

  return (
    <S.ContentWrapper>
      <S.TickerWrapper>
        <S.Ticker>
          <S.LeftImageContainer>
            <AssetLogoContainer size={40} entity={entity} />
          </S.LeftImageContainer>
          <S.TitleContainer>
            <span data-testid={`label${entityName}`}>{entityName}</span>
            <S.Tag>{ticker}</S.Tag>
          </S.TitleContainer>
        </S.Ticker>
      </S.TickerWrapper>
      <S.WatchlistWrapper>
        <WatchlistTrigger
          tag={entity.tag}
          dropdownProps={{
            strategy: 'fixed',
            placement: 'top-start',
            inPortal: false,
          }}
          renderTrigger={isInWatchlist => (
            <S.CustomWatchlistButton
              data-testid="watchlist-button"
              size="xsmall"
              variant="tertiary"
              iconName={isInWatchlist ? 'Checkmark' : 'Add'}
              $isActive={isInWatchlist}
            />
          )}
        />
      </S.WatchlistWrapper>
    </S.ContentWrapper>
  );
};

EntityHeaderWatchlist.Styled = S;
